'use client';

import React, { useId } from 'react';

interface AssistantRobotIconProps {
  /** Size and color. The robot is drawn in `currentColor`, so `text-white` / `text-brand-600` set it. */
  className?: string;
}

/**
 * The CheerVue Assistant mark: a chat-bubble robot. The eyes and smile are cut out of the
 * face and sit over the 55%-opacity ear bar, so they read as a lighter tint of the icon color.
 * Width:height is 918:675 — size it with a width class and `h-auto`, or both.
 */
export default function AssistantRobotIcon({ className }: AssistantRobotIconProps) {
  const maskId = `assistant-robot-face-${useId().replace(/:/g, '')}`;

  return (
    <svg
      viewBox="50 95 918 675"
      className={className ? `shrink-0 ${className}` : 'shrink-0'}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="1024" height="860">
          <rect x="130" y="103" width="758" height="539" rx="150" fill="#fff" />
          <path d="M290 600 L302 742 Q305 770 330 752 L445 600 Z" fill="#fff" />
          <rect x="287" y="253" width="98" height="172" rx="49" fill="#000" />
          <rect x="632" y="253" width="98" height="172" rx="49" fill="#000" />
          <path
            d="M447 420 Q447 413 454 413 H563 Q570 413 570 420 A61.5 61.5 0 0 1 447 420 Z"
            fill="#000"
          />
        </mask>
      </defs>
      <rect x="60" y="212" width="898" height="318" rx="130" fill="currentColor" fillOpacity={0.55} />
      <rect x="0" y="0" width="1024" height="860" fill="currentColor" mask={`url(#${maskId})`} />
    </svg>
  );
}
